import { paths } from '../../../../settings';
import styles from './SearchFlatButton.module.css';

type TSearchFlatButton = {
    onHandleClick: () => void;
}

const SearchFlatButton: React.FC<TSearchFlatButton> = ({ onHandleClick }): JSX.Element => {
    return (
        <div className={styles.wrapper} role="button" onClick={onHandleClick}>
            <img src={`${paths.assets}/icons/search.png`} width={60} height={60} alt="Szukaj" />
            <span>Wyszukaj Apartament</span>
        </div>
    );
};

export default SearchFlatButton;